import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { TbSparkles } from "react-icons/tb";
import styles from "./assistant.module.css";

// The panel's code loads the first time it opens.
const AssistantPanel = dynamic(() => import("./AssistantPanel"), { ssr: false });

// The assistant on every page: a small button in the corner (or Ctrl+/ / ⌘/) opens its panel.
export default function Assistant() {
  const [open, setOpen] = useState(false), [loaded, setLoaded] = useState(false), [prompt, setPrompt] = useState(null);
  useEffect(() => { if (open) setLoaded(true); }, [open]);
  useEffect(() => {
    const toggle = (event) => { if ((event.ctrlKey || event.metaKey) && event.key === "/") { event.preventDefault(); setOpen((value) => !value); } };
    // The menu's Ask (src/components/layout/Navigation.js), and tools that hand it words to start from.
    const ask = (event) => { setOpen(true); if (event.detail?.text) setPrompt({ text: event.detail.text, at: Date.now() }); };
    window.addEventListener("keydown", toggle);
    window.addEventListener("truechops:ask", ask);
    // The corner the button takes, so a practice session's bar sits above it.
    document.documentElement.style.setProperty("--assistant-launcher", "56px");
    return () => { window.removeEventListener("keydown", toggle); window.removeEventListener("truechops:ask", ask); document.documentElement.style.removeProperty("--assistant-launcher"); };
  }, []);
  return <>
    {!open && <button type="button" className={styles.launcher} onClick={() => setOpen(true)} aria-label="Open the assistant" aria-controls="assistant-panel" aria-expanded={open} title="Assistant (Ctrl+/)">
      <TbSparkles aria-hidden="true" /></button>}
    {loaded && <AssistantPanel open={open} prompt={prompt} onClose={() => setOpen(false)} />}
  </>;
}
